import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const PaymentResultPage: React.FC = () => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const status = searchParams.get('status') // 'success' or 'cancel' retrieved from URL logic if needed, but we use separate routes usually.

    // However, Stripe redirects to specific URLs. We can reuse this component for both if we identify path.
    const isSuccess = window.location.pathname.includes('success')

    useEffect(() => {
        if (isSuccess) {
            // Could trigger a toast or confetti here
            const timer = setTimeout(() => {
                navigate('/') // Redirect to dashboard after a delay
            }, 5000)
            return () => clearTimeout(timer)
        }
    }, [isSuccess, navigate])

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 max-w-md w-full text-center">
                {isSuccess ? (
                    <>
                        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                            ¡Pago Exitoso!
                        </h2>
                        <p className="text-gray-600 dark:text-gray-300 mb-8">
                            Gracias por suscribirte a Premium. Tu cuenta ha sido actualizada y ahora tienes acceso ilimitado.
                        </p>
                        <button
                            onClick={() => navigate('/')}
                            className="btn btn-primary w-full"
                        >
                            Ir al Inicio
                        </button>
                        <p className="text-xs text-gray-400 mt-4">
                            Serás redirigido automáticamente en 5 segundos...
                        </p>
                    </>
                ) : (
                    <>
                        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                            Pago Cancelado
                        </h2>
                        <p className="text-gray-600 dark:text-gray-300 mb-8">
                            El proceso de pago fue cancelado. No se ha realizado ningún cargo en tu tarjeta.
                        </p>
                        <div className="space-y-3">
                            <button
                                onClick={() => navigate('/pricing')}
                                className="btn btn-primary w-full"
                            >
                                Intentar Nuevamente
                            </button>
                            <button
                                onClick={() => navigate('/')}
                                className="btn btn-secondary w-full"
                            >
                                Volver al Inicio
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default PaymentResultPage
